import {useMediaQuery} from 'react-responsive';

const useBreakpointLG = (): boolean => useMediaQuery({minWidth: 992});

export default useBreakpointLG;
